import generationImg from "./generation.jpg";
import regionImg from "./region.jpg";
import pokedexImg from "./pokedex.jpg";

const homeImg = {
    generation: generationImg,
    region: regionImg,
    pokedex: pokedexImg
}

export default homeImg;
